define(['underscore', '../models/AdditionalTile', 'text!./templates/pa-quick-additional-tile.html'], (_, additionalTile, template) => [() => ({
    'restrict': 'A',
    template,
    'scope': {
        'stepIdx': '=',
        'tileModel': '=gwPaQuickAdditionalTile',
        'panelsValid': '='
    },
    controller: ['$scope', ($scope) => {
        $scope.model = additionalTile($scope.tileModel);

        $scope.panelsValid.isValid = () => _.chain($scope.tileModel.viewModel).pick('termsChecked', 'email', 'age').values().every(prop => prop.aspects.valid).value();
        $scope.$watch('model.isComplete', (isCompleted)=> {
            $scope.tileModel.actions.setStepCompleted($scope.stepIdx, isCompleted);
        });
        $scope.$watch('model.state.id', (state)=> {
            if (state === 'attemptingQuote') {
                $scope.tileModel.startQuoting();
            }
        });
    }]
})]);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/additional/directives/PAQuickAdditionalTile.js
 **/